import { getFolderDetail } from "../../Andes_v2/library";
import { ROCKY } from "../../auroraVersion";

class IBISAMIConstructor {
  constructor() {
    this.IBISLibraryList = new Map();
  }

  setInfo = (libraryId, data) => {
    this.IBISLibraryList.set(libraryId, data)
  }

  getInfo = (libraryId) => {
    return this.IBISLibraryList.get(libraryId)
  }

  getDetailPromise = (libraryId, update) => {
    return new Promise((resolve, reject) => {
      const info = this.getInfo(libraryId)
      if (info && !update) {
        resolve(JSON.parse(JSON.stringify(info)));
      } else {
        getFolderDetail(libraryId, ROCKY).then(res => {
          if (res) {
            this.setInfo(libraryId, res)
            resolve(res);
          } else {
            resolve(null);
          }
        }, error => {
          console.error(error);
          resolve(null);
        })
      }
    })
  }

  getFileIbisAmiInfo = (libraryId, fileName) => {
    const info = this.getInfo(libraryId);
    if (info && info.length) {
      const findFileInfo = info.find(item => item.fileName === fileName);
      return findFileInfo && findFileInfo.ibisAmi ? findFileInfo.ibisAmi : null;
    }
    return null
  }

  getFileIbisAmiInfoPromise = async (libraryId, fileName) => {
    const info = await this.getDetailPromise(libraryId);
    if (info && info.length) {
      const findFileInfo = info.find(item => item.fileName === fileName);
      return findFileInfo && findFileInfo.ibisAmi ? findFileInfo.ibisAmi : null;
    }
    return null
  }

  getFileIsAmiPromise = async (libraryId, fileName) => {
    const ibisAmi = await this.getFileIbisAmiInfoPromise(libraryId, fileName)
    if (ibisAmi && ibisAmi.amis && ibisAmi.amis.length) {
      return true;
    }
    return false;
  }

  getModelsInFileIsAmiPromise = async (libraryId, fileName, modelName) => {
    const ibisAmi = await this.getFileIbisAmiInfoPromise(libraryId, fileName)
    if (ibisAmi && ibisAmi.models) {
      const findModels = ibisAmi.models.find(item => item.name === modelName);
      if (findModels && findModels.algorithmicModels && findModels.algorithmicModels.length) {
        return true
      }
    }
    return false;
  }

  delete = (libraryId) => {
    this.IBISLibraryList.delete(libraryId)
  }

  clearAll = () => {
    this.IBISLibraryList = new Map();
  }
}

let ibisAMIConstructor = new IBISAMIConstructor();
export default ibisAMIConstructor;